/**
 * Admin booking creation: the API refuses (409 VEHICLE_NOT_AVAILABLE) when the car, yacht or
 * driver is already booked or held for those dates. Ask the admin whether to book anyway;
 * if so, resend with overrideAvailability (the API records the override on the booking).
 */
export async function postWithAvailabilityOverride(
  send: (body: unknown) => Promise<Response>,
  bookingData: Record<string, unknown>
): Promise<Response> {
  const response = await send(bookingData);
  if (response.status !== 409) return response;

  let message = 'This vehicle is already booked or held for these dates.';
  let code = '';
  try {
    const body = await response.clone().json();
    code = body?.error?.code || '';
    message = body?.error?.message || message;
  } catch {
    // not JSON — treat as a normal error below
  }
  if (code !== 'VEHICLE_NOT_AVAILABLE') return response;

  if (!window.confirm(`${message}\n\nBook anyway? This overrides availability and is recorded on the booking.`)) {
    return response;
  }
  return send({ ...bookingData, overrideAvailability: true });
}
